export default "__VITE_ASSET__5L8_WcFf__"